import { createContext } from "react";

const UserContext = createContext({
  role: {},
  setRole: () => {},
  locale: "en",
  setLocale: () => {},
});

export default UserContext;
